import { userPreferencesFavoriteSearchApi } from '@/main/api';
import { RoutesConstants } from "@/main/routes/routesConstants";
import { isEmpty } from '@/main/services/utils';
import { z } from "zod";

export const KeyValueSchema = z.object({
  key: z.union([z.string(), z.number()]),
  value: z.string(),
});

export const formSchema = z.object({
  claimNumber: z.string().optional(),
  initialTotalLoss: z.string().optional(),
  finalTotalLoss: z.string().optional(),
  insurer: KeyValueSchema.nullable().optional(),
  bodyshopBranch: z.array(KeyValueSchema).nullish().transform(v => v ?? []),
  subModel: z.string().optional(),
  vehicleManufacturer: z.string().optional(),
  vehicleModel: z.string().optional(),
  vehicle: z.string().optional(),
  status: z.array(KeyValueSchema).nullish().transform(v => v ?? []),
  state: z.array(KeyValueSchema).nullish().transform(v => v ?? []),
  delayedClaim: z.boolean().optional(),
  delayedParts: z.boolean().optional(),
  unreadComments: z.boolean().optional(),
  havingItemCanceledBySupplier: z.boolean().optional(),
  sortByOldest: KeyValueSchema.nullable().optional(),
});

export type TypeUserPredefinedFavoriteSearch = z.infer<typeof formSchema>;

export function mapUserPredefinedFavoriteToForm(data: any): TypeUserPredefinedFavoriteSearch {
  return {
    claimNumber: data.claimNumber ?? "",
    initialTotalLoss: data.initialTotalLoss ?? "",
    finalTotalLoss: data.finalTotalLoss ?? "",
    insurer: data.insurer ?? null,
    bodyshopBranch: Array.isArray(data.bodyshopBranch) ? data.bodyshopBranch : [],
    status: Array.isArray(data.status) ? data.status : [],
    state: Array.isArray(data.state) ? data.state : [],
    delayedClaim: !!data.delayedClaim,
    delayedParts: !!data.delayedParts,
    unreadComments: !!data.unreadComments,
    havingItemCanceledBySupplier: !!data.havingItemCanceledBySupplier,
    sortByOldest: data.sortByOldest ?? null,
    vehicleManufacturer: data.vehicleManufacturer ?? "",
    vehicleModel: data.vehicleModel ?? "",
    subModel: data.subModel ?? "",
    vehicle: data.vehicle ?? "",
  };
}


export async function saveFavoriteSearch( data: TypeUserPredefinedFavoriteSearch | null): Promise<boolean> {
  try {
    await userPreferencesFavoriteSearchApi.saveUserPreferencesFavoriteSearch({
      routeUrl: RoutesConstants.claimSearchClaims,
      jsonData: data ? JSON.stringify(data) : "",
    });

    return true;
  } catch {
    return false;
  }
}


export async function getFavoriteSearch(): Promise<TypeUserPredefinedFavoriteSearch | null> {
  try {
    const response = await userPreferencesFavoriteSearchApi.getUserPreferencesFavoriteSearch<any>(
      RoutesConstants.claimSearchClaims
    );

    if (isEmpty(response?.data?.result)) return null

    return mapUserPredefinedFavoriteToForm(response.data.result);
  } catch {
    return null;
  }
}

export async function saveUserPredefinedSearch( data: TypeUserPredefinedFavoriteSearch | null, description: string
): Promise<boolean> {

  try {
    await userPreferencesFavoriteSearchApi.saveUserPredefinedSearch({
      routeUrl: RoutesConstants.claimSearchClaims,
      jsonData: data ? JSON.stringify(data) : "",
      description
    });

    return true;
  } catch {
    return false;
  }
}

export async function getDetailsUserPredefinedSearch(guidUserPredefinedSearch: string): Promise<TypeUserPredefinedFavoriteSearch | null> {
  try {
    const response = await userPreferencesFavoriteSearchApi.getDetailsUserPredefinedSearch<any>(
      guidUserPredefinedSearch
    );

    if (response?.data?.result) {
      return mapUserPredefinedFavoriteToForm(response.data.result);
    }

    return null;

  } catch {
    return null;
  }
}

export async function deleteUserPredefinedSearch( guidUserPredefinedSearch: string ): Promise<boolean>  {
  try {
    const response = await userPreferencesFavoriteSearchApi.deleteUserPredefinedSearch(
      guidUserPredefinedSearch
    );
    return true;
  } catch {
    return false;
  }
}
